import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6079e968"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "absence-value"
}

import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '../../../models';
import { computed, PropType } from 'vue';
import { TaskCardItemWrapper } from './';
import { ChartBarIcon } from 'tir-style-system/icons/outline';
import { PopoverColorEnum, PopoverPositionEnum, TirPmPopover } from 'tir-components';
import {
  TaskParameter,
  TaskParameterModel,
  TaskParameterTypeEnum,
} from '@/components/task-parameter';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-difficulty',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
  /**Укороченная информация */
  shortInfoParameter: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



const difficulty = computed(() => {
  return new TaskParameterModel({
    Id: props.task.Difficulty.DifficultyId,
    Name: props.task.Difficulty.DifficultyName,
    Color: props.task.Difficulty.DifficultyColor,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskCardItemWrapper), { element: __props.element }, {
    default: _withCtx(() => [
      (__props.task.Difficulty)
        ? (_openBlock(), _createBlock(_unref(TaskParameter), {
            key: 0,
            preview: "",
            hideRemove: "",
            shortInfoParameter: __props.shortInfoParameter,
            isEditing: false,
            type: _unref(TaskParameterTypeEnum).Difficulty,
            data: difficulty.value
          }, null, 8, ["shortInfoParameter", "type", "data"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_1, "-"))
    ]),
    _: 1
  }, 8, ["element"]))
}
}

})